import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f2b38ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex h-full w-full flex-col" }
const _hoisted_2 = { class: "item-favorites-header" }
const _hoisted_3 = { class: "item-favorites-list" }
const _hoisted_4 = { class: "item-favorites-actions" }


import ItemFavoritesActions from '@/components/ItemFavorites/ItemFavoritesActions.vue';
import ItemFavoritesHeader from '@/components/ItemFavorites/ItemFavoritesHeader.vue';
import ItemFavoritesList from '@/components/ItemFavorites/ItemFavoritesList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemFavorites',
  emits: {
  effect: null,
},
  setup(__props, { emit }) {



const triggerItemFavoritesEffect = (): void => {
  emit('effect');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ItemFavoritesHeader)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ItemFavoritesList, { onEffect: triggerItemFavoritesEffect })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ItemFavoritesActions)
    ])
  ]))
}
}

})